import { define } from 'wicked-elements'
import { onClickOutside } from '@bounoable/on-click-outside'

define('[data-component="navigation"]', {
  init() {
    this.$navMobile = this.element.querySelector('[data-nav-mobile]')
    this.$navToggle = this.element.querySelector('[data-nav-toggle]')
    this.$navMobileLinks = this.$navMobile.querySelector('ul')
    this.handleNavClick = this.handleNavClick.bind(this)
    this.handleClickOutside = this.handleClickOutside.bind(this)
    this.clickOutside = null
  },
  connected() {
    this.$navToggle.addEventListener('click', this.handleNavClick)
    this.clickOutside = onClickOutside(this.element, this.handleClickOutside)
  },
  disconnected() {
    this.$navToggle.removeEventListener('click', this.handleNavClick)
    this.clickOutside()
  },
  handleNavClick() {
    if (this.$navMobile.classList.contains('nav-open')) {
      this.$navMobile.classList.remove('nav-open')
      this.$navMobileLinks.classList.add('hidden')
      this.$navMobileLinks.classList.remove('flex')
    } else {
      this.$navMobile.classList.add('nav-open')
      this.$navMobileLinks.classList.remove('hidden')
      this.$navMobileLinks.classList.add('flex')
    }
  },
  handleClickOutside(e) {
    this.$navMobile.classList.remove('nav-open')
    this.$navMobileLinks.classList.add('hidden')
    this.$navMobileLinks.classList.remove('flex')
  },
})